<template>
  <v-card>
    <v-card-title>{{ $t("participant.live.challengeCompleteConfirmation.popup.title") }}</v-card-title>
    <v-card-text>
      <p>{{ $t("participant.live.challengeCompleteConfirmation.popup.intro") }}</p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="runEndedClick">{{
        $t("participant.live.challengeCompleteConfirmation.popup.yes")
      }}</v-btn>
      <v-btn color="secondary" @click="postpone">{{
        $t("participant.live.challengeCompleteConfirmation.popup.notYet")
      }}</v-btn>
      <v-btn color="secondary" text type="submit" @click="continueClick">{{
        $t("participant.live.challengeCompleteConfirmation.popup.skip")
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ParticipantChallengeCompleteConfirmation",
  methods: {
    continueClick() {
      this.$emit("continue");
    },
    runEndedClick() {
      this.$emit("runEnded");
    },
    postpone() {
      this.$emit("postpone");
    },
  },
};
</script>

<style scoped></style>
